/**
 * Shown instead of a sign-in form on a surface that isn't open yet. A drop-in swap for
 * <SignInPage surface="..."/> — turning a surface back on later is restoring one line in
 * RestaurantApp/DriverApp/App, not re-adding deleted routes and pages, since the sign-in
 * code underneath stays exactly where it was.
 */
export function SurfaceUnavailable({ portalName }: { portalName: string }) {
  return (
    <div className="auth-page">
      <h1>Not available yet</h1>
      <p className="muted">
        {portalName} sign-in isn't open yet. Check back soon.
      </p>
    </div>
  );
}
